import { defaultSubCategory, defaultFilterSgaSubCategories } from "./state";

/**
 * Mutación que lista las subcategorías de SGA .
 *
 * @param {*} state.subCategories - Estado de las subcategorías de SGA.
 * @param subCategories - Subcategorías de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setSubCategoriesSga(state, subCategories) {
    state.subCategories = subCategories;
}

/**
 * Mutación que establece la acción a realizar (Crear o actualizar).
 *
 * @param {*} state.action - Estado de la acción.
 * @param action - Acción a realizar (create o edit).
 * @return {void}
 * @author Brandon Torres
 */
export function setActionSubCategory(state, action) {
    state.action = action;
}

/**
 * Mutación que establece la subcategoría por defecto.
 *
 * @param {*} state.subCategory - Estado de la subcategoría.
 * @return {void}
 * @author Brandon Torres
 */
export function setdefaultSubCategorySga(state) {
    state.subCategory = defaultSubCategory();
}

/**
 * Mutación que establece el filtro de subcategorías de SGA por defecto.
 *
 * @param {*} state.filterSubCategoriesSga - Estado del filtro de subcategorías de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setdefaultFilterSgaSubCategories(state) {
    state.filterSubCategoriesSga = defaultFilterSgaSubCategories();
}

/**
 * Mutación que establece la cantidad de subcategorías por página.
 *
 * @param {*} state.filterSubCategoriesSga.per_page - Cantidad de registros por página.
 * @param {*} state.filterSubCategoriesSga.page - Página actual.
 * @param per_page - Cambio de cantidad de registros por página.
 * @return {void}
 * @author Brandon Torres
 */
export function loadAfterChangeSizePagination(state, per_page) {
    state.filterSubCategoriesSga = {
        ...state.filterSubCategoriesSga,
        page: 1,
        per_page: per_page,
    };
}

/**
 * Mutación que establece la página actual.
 *
 * @param {*} state.filterSubCategoriesSga.page - Página actual.
 * @param page - Cambio de página actual.
 * @return {void}
 * @author Brandon Torres
 */
export function loadAfterChangePagePagination(state, page) {
    state.filterSubCategoriesSga.page = page;
}

/**
 * Mutación que establece el paginador de registros de subcategorías.
 *
 * @param {*} state.filterSubCategoriesSga.page - Página actual.
 * @param {*} state.filterSubCategoriesSga.per_page - Cantidad de registros por página.
 * @param {*} state.filterSubCategoriesSga.total - Total de registros.
 * @param paginate - Paginación de registros.
 * @return {void}
 * @author Brandon Torres
 */
export function setPaginateSubCategoriesSga(state, paginate) {
    state.filterSubCategoriesSga = {
        ...state.filterSubCategoriesSga,
        page: paginate.current_page,
        per_page: paginate.per_page,
        total: paginate.total,
    };
}

/**
 * Mutación que establece la subcategoría de SGA.
 *
 * @param {*} state.subCategory - Estado de la subcategoría.
 * @param subCategory - Subcategoría de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setSubCategorySga(state, subCategory) {
    state.subCategory = {
        id: subCategory.id,
        sga_sub_category_type_id: subCategory.sga_sub_category_type_id,
        sga_category_id: subCategory.sga_category_id,
        sga_sub_category_languages: subCategory.sga_sub_category_languages,
        word_of_caution_id: subCategory.word_of_caution_id,
        sga_sub_category_word_of_caution:
            subCategory.sga_sub_category_word_of_caution,
        combined_names: subCategory.combined_names,
        sga_sub_category_pictograms: subCategory.sga_sub_category_pictograms,
        pictograms_ids: [],
        sga_sub_category_danger_indication_codes:
            subCategory.sga_sub_category_danger_indication_codes,
        danger_indication_codes_ids: [],
        except_countries_ids: subCategory.except_countries_ids,
    };
}

/**
 * Mutación que establece la lista de subcategorias por versión de SGA.
 *
 * @param {*} state.subCategoriesByVersion - Lista de subcategorias por versión de SGA.
 * @param subCategoriesByVersion - Subcategorias por versión de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setSubCategoriesByVersion(state, subCategoriesByVersion) {
    state.subCategoriesByVersion = subCategoriesByVersion;
}
